import { insertAfter } from "../helpers/elements";
import AcHtmlElement from "../helpers/html-element";
var ActionButton = /** @class */ (function () {
    function ActionButton(el) {
        this.el = el;
        this.visible = true;
    }
    ActionButton.prototype.toggle = function (show) {
        this.visible = show;
        return this;
    };
    ActionButton.prototype.isHidden = function () {
        return !this.visible;
    };
    ActionButton.prototype.getElement = function () {
        return new AcHtmlElement(this.el);
    };
    ActionButton.prototype.setTooltip = function (tooltip) {
        this.el.dataset.acTip = tooltip;
        return this;
    };
    ActionButton.createWithMarkup = function (slug, label) {
        return new ActionButton(AcHtmlElement
            .create('a')
            .setAttribute('data-slug', slug)
            .addClasses('ac-table-button')
            .addHtml(label).getElement());
    };
    return ActionButton;
}());
export { ActionButton };
var ActionButtonCollection = /** @class */ (function () {
    function ActionButtonCollection(data) {
        this.data = data;
    }
    ActionButtonCollection.prototype.add = function (button, priority) {
        if (!(priority in this.data)) {
            this.data[priority] = [];
        }
        this.data[priority].push(button);
    };
    ActionButtonCollection.prototype.getById = function (id) {
        this.getButtons().find(function (b) { return b.getElement().getElement().id === id; });
    };
    ActionButtonCollection.prototype.getButtons = function () {
        var _this = this;
        var result = [];
        Object.keys(this.data).forEach(function (priority) {
            _this.data[parseInt(priority)].forEach(function (button) {
                result.push(button);
            });
        });
        return result;
    };
    ActionButtonCollection.prototype.getReversedButtons = function () {
        return this.getButtons().reverse();
    };
    return ActionButtonCollection;
}());
var Actions = /** @class */ (function () {
    function Actions(container) {
        this.container = container;
        this.buttons = new ActionButtonCollection({});
        this.init();
    }
    Actions.prototype.getButton = function (id) {
        return this.buttons.getById(id);
    };
    Actions.prototype.addButton = function (button, priority) {
        this.buttons.add(button, priority);
    };
    Actions.prototype.init = function () {
        var _this = this;
        this.container.addEventListener('update', function () {
            _this.refresh();
        });
        document.querySelectorAll('.tablenav.top .actions').forEach(function (el) {
            insertAfter(_this.container, el);
            _this.container.classList.add('-init');
        });
        this.container.querySelectorAll('.ac-table-actions-buttons .ac-table-button').forEach(function (button) {
            var _a, _b;
            var actionButton = new ActionButton(button);
            if (!button.offsetParent) {
                actionButton.toggle(false);
                actionButton.getElement().getElement().remove();
            }
            _this.addButton(actionButton, parseInt((_b = (_a = button.dataset) === null || _a === void 0 ? void 0 : _a.priority) !== null && _b !== void 0 ? _b : '10'));
        });
    };
    Actions.prototype.getElement = function () {
        return this.container;
    };
    Actions.prototype.toggle = function (show) {
        if (show === void 0) { show = true; }
        if (show) {
            this.getElement().classList.remove('-hidden');
        }
        else {
            this.getElement().classList.add('-hidden');
        }
    };
    Actions.prototype.refresh = function () {
        var _this = this;
        this.buttons.getButtons().forEach(function (button) {
            var _a;
            if (button.isHidden()) {
                button.getElement().getElement().remove();
            }
            else {
                (_a = _this.container.querySelector('.ac-table-actions-buttons')) === null || _a === void 0 ? void 0 : _a.append(button.getElement().getElement());
            }
        });
        this.toggle(this.buttons.getButtons().length !== 0);
    };
    return Actions;
}());
export default Actions;
